import axios from "axios";
import { handleHttpErrors } from "../../../modules/http";
import { getClaims } from "../../../modules/login";
import {
  blockUnblockUser,
  unlockUser,
} from "../../../modules/profileManagement";
import { UserStatus } from "../../library/AccountStatus/AccountStatus.constants";
import {
  orderType,
  tablePageSizes,
} from "../../ui-library/CustomTable/constants";

// Constants
const LOADING_CAREGIVERS = "LOADING_CAREGIVERS";
const SET_CAREGIVERS = "SET_CAREGIVERS";
const RESET_STATE = "RESET_STATE";
const LOGOUT = "LOGOUT";

// Acessors
const getCaregivers = (state) => state?.caregivers;
const getTotalItems = (state) => state?.totalItems;
const getSearchedParams = (state) => state?.searchedParams;
const getLoading = (state) => state?.loading;

const canCreateCaregiver = (state) => getClaims(state, "caregiver.canCreate");
const canViewCaregiverTemporaryPassword = (state) =>
  getClaims(state, "caregiver.temporaryPassword.canCreate");
const canUnLockCaregiver = (state) => getClaims(state, "caregiver.canUnlock");
const canUnblockCaregiver = (state) => getClaims(state, "caregiver.canBlock");
const canEditCaregiver = (state) =>
  getClaims(state, "caregiver.canManageCaregivers");

// Default state
const initialState = {
  caregivers: [],
  totalItems: null,
  loading: false,
  searchedParams: {
    page: 0,
    limit: tablePageSizes[0],
    search: "",
    orderBy: "date",
    order: orderType.DESC,
    filter: UserStatus.ALL.id,
  },
};

export const caregiversTableReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADING_CAREGIVERS:
      return {
        ...state,
        loading: true,
      };
    case SET_CAREGIVERS:
      const { data } = action;
      return {
        ...state,
        caregivers: data.data,
        totalItems: data.records,
        searchedParams: action.searchedParams,
        loading: false,
      };
    case RESET_STATE:
      return initialState;
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

const resetState = () => (dispatch) => {
  dispatch({ type: RESET_STATE });
};

const fetchCaregivers = (participantId, searchedParams) => (dispatch) => {
  const params = {
    ...searchedParams,
    participantId,
  };

  dispatch({
    type: LOADING_CAREGIVERS,
  });

  return axios
    .get(`/api/participant/user`, { params })
    .then((data) => {
      dispatch({
        type: SET_CAREGIVERS,
        data,
        searchedParams,
      });
    })
    .catch((error) => {
      // if statement to avoid to show an error when the request is canceled
      if (error?.message === "cancel") {
        return;
      }

      const defaultMessage = error.response?.data
        ? error.response.data
        : "There was an error while trying to fetch caregivers!";

      return handleHttpErrors(error.request?.status, {
        default: defaultMessage,
      });
    });
};

export const mapStateToProps = (state) => {
  return {
    caregivers: getCaregivers(state),
    totalItems: getTotalItems(state),
    searchedParams: getSearchedParams(state),
    loading: getLoading(state),
    canCreateCaregiver: canCreateCaregiver(state),
    canViewCaregiverTemporaryPassword: canViewCaregiverTemporaryPassword(state),
    canUnLockCaregiver: canUnLockCaregiver(state),
    canUnblockCaregiver: canUnblockCaregiver(state),
    canEditCaregiver: canEditCaregiver(state),
  };
};

export const mapDispatchToProps = {
  fetchCaregivers,
  unlockUser,
  blockUnblockUser,
  resetState,
};
